import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchedProfiles, fetchPofiles } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchPofiles>;

export function* getProfilesSaga({ meta: { callback } }: FetchActionPayload) {
  const { getProfilesList } = getAPI();
  const response: YieldOf<typeof getProfilesList> = yield call(getProfilesList);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedProfiles(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedProfiles(undefined, error));
  }

  if (callback) callback();
}

export default function* profilesSaga() {
  yield takeLatest(fetchPofiles.type, getProfilesSaga);
}
